module.exports = __webpack_public_path__ + "static/img/ux.54df95a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Pods/ux.png
// module id = vZAz
// module chunks = 0